<template lang="pug">
aside.sidebar.branded
  nav
    .group-top
      ul.menu.roles
        MenuItem(:id="$Constants.Roles.TypeName" :icon="$icons.roles" name="Roles" :to="$site.Routes.Roles.Root")

      component(v-if="currentRole" :is="currentRole.type")

    .group-bottom
      ul.menu
        MenuItem(v-if="currentRole" :id="$Constants.Setting.TypeName" :icon="$icons.settings" name="Settings" :to="$site.Routes.Settings.Root")

        li(id="logout")
          a(href="#" @click.prevent="logout")
            .name
              FontAwesomeIcon.icon(:icon="$icons.logout")
              p Logout

        li(id="help")
          a(:href="$Constants.SaveTrees.Www.Help" target="_blank")
            .name
              FontAwesomeIcon.icon(:icon="$icons.help")
              p Help

        li.open-zammad-chat(v-if="showSupportChat && chat" id="support")
          a(href="#")
            .name
              FontAwesomeIcon.icon(:icon="$icons.chat")
              p Raise support issue

      .system-info
        p.powered-by Powered by&nbsp;
          a(:href="$Constants.SaveTrees.Www.Home" target="_blank") SaveTrees
        a.version(:href="$Constants.SaveTrees.Www.Blog" target="_blank" :class="this.$app.constants.instance")
          p(v-if="this.$app.constants.instance === 'live'") version: {{ this.$app.constants.version.short }}
          template(v-else)
            p {{ this.$app.constants.instance }} / {{ this.$app.constants.version.short }}
            p(v-if="this.$app.constants.releaseDate") {{ this.$app.constants.releaseDate }}
  </template>

<script>
import MenuItem from "./MenuItem.vue";
import { logout } from "@/utils";
import "./scss";
import { WebApplicationConstants } from "@/setup/WebApplicationConstants";

export default {
  name: "Sidebar",
  components: {
    MenuItem,
    RecruitmentAgencyAdministrationRole: () => import("./RecruitmentAgencyAdministrationRole/Index"),
    ContractingRole: () => import("./ContractingRole/Index"),
    AuthorisingRole: () => import("./AuthorisingRole/Index"),
  },
  props: {
    expanded: {
      type: Boolean,
    },
  },
  computed: {
    showSupportChat() {
      return !this.$app.isIE11 && this.isRecruitmentAgencyAdministrationRole;
    },
  },
  data() {
    return {
      chat: undefined,
      active: undefined,
      currentMenuItem: {
        iconName: this.$icons.roles,
        path: this.$site.Routes.Roles.Root,
      },
    };
  },
  created() {
    this.configureChat();
  },
  watch: {
    currentRole() {
      this.configureChat();
    },
    $route(to, from) {
      if (to.path === this.currentMenuItem.path || to.path === from.path) {
        return;
      }
      this.setActiveMenuItem(to);
      if (this.expanded && window.Breakpoints.is("xs")) {
        WebApplicationConstants.eventBus.publish(new this.$Events.NavbarToggledEvent());
      }
    },
  },
  methods: {
    async logout() {
      await logout(this.$app.api);
    },
    async setActiveMenuItem(newRoute) {
      // Todo: Find out why this is firing multiple times
      if (newRoute.path === this.currentMenuItem.path) {
        return;
      }

      this.currentMenuItem.iconName = newRoute.name;
      this.currentMenuItem.path = newRoute.path;
    },
    configureChat() {
      if (this.showSupportChat && !this.chat) {
        try {
          this.chat = new ZammadChat({
            fontSize: "12px",
            chatId: 1,
            title: "Tell us about your issue",
            show: false,
          });
        } catch (error) {
          WebApplicationConstants.defaultLogger.error(error);
        }
      }
    },
  },
};
</script>
